module.exports = __webpack_public_path__ + "static/media/14@1920w.3446e976.jpg";